'use strict';
const Backbone = require('backbone');
const Content = require('data/domain/entity/content/index');
const moment = require('moment');

/**
 * Content の Collection を表現する
 *
 * Collection は必ず一つの Container に所属している
 */
module.exports = Backbone.Collection.extend({
    model: Content,

    initialize: function(options, test, args) {
        this._containerID = args.containerID;
        this._repository = args.repository;
    },

    comparator: function(content) {
        return - moment(content.getUpdatedAt()).unix();
    },

    hasNext: function() {
        return this._more;
    },

    setNext: function(more) {
        this._more = more;
    },

    setCursor: function(cursor) {
        this._cursor = cursor;
    },

    fetchNext: function(limit) {
        return this._repository.fetchContents(this._containerID, limit, this._cursor);
    },

    fetchNextAll: function () {
        if (!this.hasNext()) {
            return new Promise(resolve => {
                resolve();
            });
        }
        const perPage = 20;
        return new Promise(resolve => {
            this.fetchNext(perPage)
                .then(() => {
                    this.fetchNextAll().then(() => {
                        resolve();
                    });
                });
        });
    }
});



// WEBPACK FOOTER //
// ./data/domain/collection/content/index.js